export const AUTH_SERVICE_URL = 'https://auth.wildix.com';

export const CONFERENCE_BASE_URL = config.baseUrl;

export const ANALYTICS_API_GATEWAY_URL = config.analyticsBaseUrl;
